import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import HttpBackend from 'i18next-http-backend';

// Initialize i18next
i18n
  .use(HttpBackend) // Load translations from /locales directory
  .use(LanguageDetector) // Detects language from browser
  .use(initReactI18next) // React bindings
  .init({
    fallbackLng: 'en',
    supportedLngs: ['en', 'de', 'es', 'fr', 'it', 'nl'],
    load: 'languageOnly', // Strip region codes (en-US → en) so file paths always match
    // No hardcoded lng - let LanguageDetector use browser language
    // This prevents flash of English before user preference loads
    debug: false, // Disabled - too verbose. Use custom logs below instead

    // Namespace configuration
    ns: ['common', 'auth', 'organizations', 'contacts', 'deals', 'activities', 'settings', 'dashboard', 'workflows', 'social', 'emails', 'errors', 'gmaps', 'support', 'forms', 'sequences', 'tour', 'manager-tasks', 'feedback-actions'],
    defaultNS: 'common',

    // Backend configuration for loading translations
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json',
    },

    interpolation: {
      escapeValue: false, // React already escapes
    },

    react: {
      useSuspense: true, // Use Suspense for loading translations
    },
  });

// Log language changes for debugging
i18n.on('initialized', (options) => {
  console.log('[i18n] Initialized with language:', i18n.language, '| fallback:', options.fallbackLng);
});

i18n.on('languageChanged', (lng) => {
  console.log('[i18n] Language changed to:', lng);
  console.trace('[i18n] Language change stack trace');
});

export default i18n;
